export const getNonEmptySetFromList = <T>(list?: T[]): Set<T> | undefined => {
  if (!list || list.length === 0) return undefined;
  return new Set(list);
};

export const getNonEmptyArrayNoDuplicates = <T>(
  list?: T[],
): T[] | undefined => {
  const set = getNonEmptySetFromList(list);
  if (!set) return undefined;
  return Array.from(set);
};

export const getArrayNoDuplicates = <T>(list: T[]): T[] => {
  return Array.from(new Set(list));
};
